import { ISelectItem } from '../types/form.type';

export const AVAILABLES: ISelectItem[] = [
  { value: 1, label: 'available' },
  { value: 0, label: 'unavailable' },
];
